import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const AddAdminHeadingModal = ({ isAddOpen, onAddClose, formData, setFormData, fetchData }) => {
  if (!isAddOpen) return null;


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
      if (!formData.heading.trim()) {
                      Swal.fire({
                        icon: 'warning',
                        title: 'Empty Field',
                        text: 'Enter Heading!',
                      });
                      return;
                    }
    
    try {
      Swal.fire({
                  title: "Submitting...",
                  text: "Please wait while we process your request.",
                  allowOutsideClick: false,
                  didOpen: () => {
                      Swal.showLoading();
                  },
              });
      const response = await axios.post(`https://rfs2.infraconsoft.net.in/api/adminFileManager_headingInsert`, {
        heading: formData.heading,
      });
  
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Inserted!",
          text: "Heading inserted successfully.",
        });
        onAddClose();
        fetchData();
      }
    } catch (error) {
      console.error("Error inserting department:", error);
  
      if (error.response && error.response.data && error.response.data.message) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response.data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Insert failed. Please try again.",
        });
      }
    }
  };
  
  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <button className="close-btn" onClick={onAddClose} style={{position: "initial"}}>&times;</button>
        </div>
        <h3>Add File Heading</h3>
        <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
            <div className="form-group">
                <label>Heading :</label>
                <input
            type="text"
            name="heading"
            value={formData.heading}
            onChange={handleChange}
          />
              </div>
              
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Save
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default AddAdminHeadingModal;
